// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "conversation_message".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { messageRoleValues, messageTypeValues } from '@borradh-workspace/labels';
/** Response atom for the "conversation_message" table (1:1 with a DB row, on the wire). */
export const conversationMessageAtomSchema = z.object({
    id: z.string(),
    conversationId: z.string(),
    role: z.enum(messageRoleValues),
    content: z.string(),
    messageType: z.enum(messageTypeValues),
    externalMessageId: z.string().nullable(),
    origin: z.string(),
    metadata: z.unknown().nullable(),
    sentAt: z.string().datetime().nullable(),
    deliveredAt: z.string().datetime().nullable(),
    readAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=conversationMessage.js.map